var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -5.048,
    y: 14.421,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 15.9999 -6.6276)",
    fill: "#FFFFFF",
    width: 42.097,
    height: 3.158
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.049,
    y: 14.422,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.6276 16.0001)",
    fill: "#FFFFFF",
    width: 42.097,
    height: 3.157
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileClose);
export default __webpack_public_path__ + "static/media/mobile-close.1ad1aa67d790c39210faead5a7d6d1e6.svg";
export { ForwardRef as ReactComponent };